import { PT_ProtectiveFunction } from "./PT_ProtectiveFunction";
import { HFTResults } from "../models/HFTResults";
import { pfdToSil } from "../helpers";

export class CalculationResultsView {
  constructor(ptProtectiveFunction: PT_ProtectiveFunction, hftResults: HFTResults) {
    if (ptProtectiveFunction != null) {
      this.pfdAvg = ptProtectiveFunction.pfdAverageDisplay;
      this.sil = pfdToSil(ptProtectiveFunction.pfdAverage).toString();
      this.str = ptProtectiveFunction.strDisplay;
      // prevents 'Infinity' from being shown in the MTTFs results box when str1Year is 0
      if (ptProtectiveFunction.stR1Year > 0) {
        this.mttf = (1 / ptProtectiveFunction.stR1Year).toFixed(2);
      }
      if (hftResults != null && hftResults.system != null) {
          this.hft = hftResults.system.toString();
      }
    }
  }

  public pfdAvg = "";
  public sil = "";
  public str = "";
  public mttf = "";
  public hft = "";
}